import "./styles.scss";

import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";

function SelectLanguages({ allowedLanguage, language, onClickOptions }) {
  const { t } = useTranslation();

  const translateLanguage = {
    FR: t("FRENCH"),
    EN: t("BTN_ENGLISH"),
    ES: t("BTN_SPANISH"),
    PT: t("BTN_PORTUGUESE"),
    "CS-US-IN": t("INTERVIEW"),
  };

  return (
    <div className="selectLanguages">
      <div className="language">
        {allowedLanguage?.includes(1) && (
          <div onClick={() => onClickOptions("EN")} className={language === "EN" ? "active" : ""}>
            <FlagIcon size={35} code={"US"} />
            <span className="titleLanguage">{translateLanguage["EN"]}</span>
          </div>
        )}
        {allowedLanguage?.includes(2) && (
          <div onClick={() => onClickOptions("ES")} className={language === "ES" ? "active" : ""}>
            <FlagIcon size={35} code={"ES"} />
            <span className="titleLanguage">{translateLanguage["ES"]}</span>
          </div>
        )}
        {allowedLanguage?.includes(3) && (
          <div onClick={() => onClickOptions("PT")} className={language === "PT" ? "active" : ""}>
            <FlagIcon size={35} code={"BR"} />
            <span className="titleLanguage">{translateLanguage["PT"]}</span>
          </div>
        )}
        {allowedLanguage?.includes(4) && (
          <div onClick={() => onClickOptions("FR")} className={language === "FR" ? "active" : ""}>
            <FlagIcon size={35} code={"FR"} />
            <span className="titleLanguage">{translateLanguage["FR"]}</span>
          </div>
        )}
        {allowedLanguage?.includes(101) && (
          <div onClick={() => onClickOptions("CS-US-IN")} className={language === "CS-US-IN" ? "active" : ""}>
            <FlagIcon size={35} code={"US"} />
            <span className="titleLanguage">{translateLanguage["CS-US-IN"]}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SelectLanguages;
